import { RouterModule, Routes } from '@angular/router';
import { AppMainComponent } from './main.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { PageLayoutsRoutes } from '../page-layouts/page-layouts-routing.module';
import { LicensePortalRoutes } from '../license-portal/license-portal-routing.module';

const routes: Routes = [
    {
        path: 'app',
        component: AppMainComponent,
        children: [
            { path: 'dashboard', component: DashboardComponent },            
            ...PageLayoutsRoutes
        ]
    },

];

export const MainRoutingModule = RouterModule.forChild(routes);




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/main-routing.module.ts